export type PromptType =
  | "Prompt::MeetingQuickSummary"
  | "Prompt::MeetingPrep"
  | "Prompt::MeetingNote"
  | "Prompt::MeetingTasks"
  | "Prompt::HouseholdSummary"

export interface Prompt {
  id: string
  content: string | null
  content_json: Record<string, unknown> | null
  guid: string
  type: PromptType
  created_at: Date
  updated_at: Date
  book_id: string
  company_id: string
}

export type PromptRunStatus = "not_started" | "active" | "retrying" | "finished" | "failed"

export interface PromptStatusDetails {
  status: PromptRunStatus
  prompt_run_guid: string | null
  started_at: Date | null
  finished_at: Date | null
  failed_at: Date | null
  error_message: string | null
}

export type PromptStatusMap = Partial<Record<PromptType, PromptStatusDetails>>

export interface PromptSettings {
  id: string
  type: PromptType
  book_id: string
  content_json: Record<string, string> | null
  effective_content_json: Record<string, string>
  default_content_json: Record<string, string>
  is_customized: boolean
  recommend_tasks: boolean
}

export interface PromptVersionHistoryEntry {
  id: number
  created_at: Date
  event: string
  whodunnit: string | null
  changed_keys: string[]
  before_content_json: Record<string, string>
  after_content_json: Record<string, string>
  before_value_for_key: string | null
  after_value_for_key: string | null
}

export interface PromptVersionHistoryResponse {
  versions: PromptVersionHistoryEntry[]
}

export const PROMPT_TYPE_LABELS: Record<PromptType, string> = {
  "Prompt::MeetingQuickSummary": "Meeting summary",
  "Prompt::MeetingPrep": "Meeting preparation",
  "Prompt::MeetingNote": "Meeting notes",
  "Prompt::MeetingTasks": "Meeting tasks",
  "Prompt::HouseholdSummary": "Household summary",
}

export const PROMPT_TYPE_SLUGS: Record<PromptType, string> = {
  "Prompt::MeetingQuickSummary": "meeting_quick_summary",
  "Prompt::MeetingPrep": "meeting_prep",
  "Prompt::MeetingNote": "meeting_note",
  "Prompt::MeetingTasks": "meeting_tasks",
  "Prompt::HouseholdSummary": "household_summary",
}

export const PROMPT_SLUG_TO_TYPE: Record<string, PromptType> = Object.fromEntries(
  Object.entries(PROMPT_TYPE_SLUGS).map(([type, slug]) => [slug, type as PromptType])
) as Record<string, PromptType>
